import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PrivateRoute from "./components/PrivateRoute";
import Login from "./templates/login";
import Dashboard from "./templates/dashboard";
import DivisionEntry from "./templates/master/division";
import RangeEntry from "./templates/master/range";
import ProjectEntry from "./templates/master/project";
import TimberEntry from "./templates/master/timber";
import PropsEntry from "./templates/master/props";
import ReceiptEntry from "./templates/project-progress/receipt";
import DisposalEntry from "./templates/project-progress/disposal";
import MonthlyProjectProgressReport from "./templates/project-progress/reports/monthly";
import Receive from "./templates/letter/receive";
import Dispatch from "./templates/letter/dispatch";
import LetterReport from "./templates/letter/report/letter";
import DateRangeReport from "./templates/letter/report/dataRange";
import DivisionWiseReport from "./templates/letter/report/divisionReport";
import SignUp from "./templates/signup";
import SubjectEntry from "./templates/master/subject";

function App() {
  window.addEventListener("error", (e) => {
    if (
      e.message ===
        "ResizeObserver loop completed with undelivered notifications." ||
      e.message === "ResizeObserver loop limit exceeded"
    ) {
      e.stopImmediatePropagation();
    }
  });

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route path="/signup" element={<SignUp />} />
        <Route
          path="/division-master"
          element={
            <PrivateRoute>
              <DivisionEntry />
            </PrivateRoute>
          }
        />
        <Route
          path="/range-master"
          element={
            <PrivateRoute>
              <RangeEntry />
            </PrivateRoute>
          }
        />
        <Route
          path="/project-master"
          element={
            <PrivateRoute>
              <ProjectEntry />
            </PrivateRoute>
          }
        />
        <Route
          path="/timber-master"
          element={
            <PrivateRoute>
              <TimberEntry />
            </PrivateRoute>
          }
        />
        <Route
          path="/props-master"
          element={
            <PrivateRoute>
              <PropsEntry />
            </PrivateRoute>
          }
        />
        <Route
          path="/subject-master"
          element={
            <PrivateRoute>
              <SubjectEntry />
            </PrivateRoute>
          }
        />
        <Route
          path="/project-progress/receipt-entry"
          element={
            <PrivateRoute>
              <ReceiptEntry />
            </PrivateRoute>
          }
        />
        <Route
          path="/project-progress/disposal-entry"
          element={
            <PrivateRoute>
              <DisposalEntry />
            </PrivateRoute>
          }
        />
        <Route
          path="/project-progress/monthly-report"
          element={
            <PrivateRoute>
              <MonthlyProjectProgressReport />
            </PrivateRoute>
          }
        />
        <Route
          path="/letter/receive"
          element={
            <PrivateRoute>
              <Receive />
            </PrivateRoute>
          }
        />
        <Route
          path="/letter/dispatch"
          element={
            <PrivateRoute>
              <Dispatch />
            </PrivateRoute>
          }
        />
        <Route
          path="/letter/letter-report"
          element={
            <PrivateRoute>
              <LetterReport />
            </PrivateRoute>
          }
        />
        <Route
          path="/letter/data-range"
          element={
            <PrivateRoute>
              <DateRangeReport />
            </PrivateRoute>
          }
        />
        <Route
          path="/letter/division-wise-report"
          element={
            <PrivateRoute>
              <DivisionWiseReport />
            </PrivateRoute>
          }
        />
        {/* <Route path="*" element={<NotFound />} /> */}
      </Routes>
    </Router>
  );
}

export default App;
